module.exports = __webpack_public_path__ + "img/ballvalves.202afa2f.jpg";